import { useContext } from 'react';

import ModalContext from './ModalContext';

/**
 * Custom hook to access modal context
 *
 * @returns ModalContextType with all modal operations and state
 * @throws Error if used outside of ModalProvider
 *
 * @example
 * ```tsx
 * const MyComponent = () => {
 *   const { updateModalContent, closeModal, isOpen } = useModal();
 *
 *   const openMyModal = () => {
 *     updateModalContent(<div>My modal content</div>);
 *   };
 *
 *   return <button onClick={openMyModal}>Open Modal</button>;
 * };
 * ```
 */
const useModal = () => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }

  return context;
};

export default useModal;
